import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, id }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={id ? `${id}-chapter` : undefined}>
    <span className="font-display text-sm text-gold/80 tabular-nums">{number}</span>
    <span className="h-px w-10 bg-gold/40" />
    <span className="overline-label">{label}</span>
  </div>
);

export const EASE_OUT = EASE;
